/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { gql, useQuery } from '@apollo/client';
import { object, func } from 'prop-types';
import mbpLogger from 'mbp-logger';

import * as app from '../../../../state/ducks/App';
import { GRAPHQL_ENV } from '../../../gql';
import { setPassportData } from '../../../../state/ducks/MfeCheckout/ducks/Passport/Passport-Action';

const findPassportContent = (brand) => (
    gql`query PassportQuery {
            findContent(brand: "${brand}", environment: "${GRAPHQL_ENV}",
                contentType:"passport"
                includeRefs:[
                    "passport_pricing_conditional_logic.at_checkout.passport_referenced_sku",
                    "passport_pricing_conditional_logic.utm_params.passport_referenced_sku",
                    "passport_messaging.user_with_expired_passport_subscription.passport_referenced_sku",
                    "passport_messaging.user_whose_passport_subscription_is_about_to_expire.passport_referenced_sku",
                    "passport_messaging.user_who_never_bought_passport_subscription.passport_referenced_sku"
                    "passport_messaging.active_passport_subscription_signed_in.passport_referenced_sku"
                    "passport_messaging.active_passport_subscription_signed_out.passport_referenced_sku"
                    "myaccount_passport.renew_button_passport_price.passport_referenced_sku",
                    "myaccount_passport.renew_early_button_passport_price.passport_referenced_sku",
                    "ab_testing.control.passport_referenced_sku",
                    "ab_testing.variant.passport_referenced_sku",
                ]) {
                    content
        }
    }
`
);

const brandSelectors = app.ducks.brand.selectors;

const GraphqlPassportContainer = ({ brand, setPassportCodeAction }) => {
    const Passport_PAGE_QUERY = findPassportContent(brand['domain-name']);
    const { loading, error, data } = useQuery(Passport_PAGE_QUERY);

    if (loading) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: Passport_PAGE_QUERY,
            component: 'GraphqlPassportContainer.js',
            message: 'Error loading data from Graphql',
            env: GRAPHQL_ENV,
            error,
        });
        return null;
    }

    if (!data) {
        mbpLogger.logWarning({
            appName: process.env.npm_package_name,
            query: Passport_PAGE_QUERY,
            component: 'GraphqlPassportContainer.js',
            message: 'No data returned for query',
            env: GRAPHQL_ENV,
        });
    } else if (!data?.findContent?.content) {
        mbpLogger.logWarning({
            appName: process.env.npm_package_name,
            query: Passport_PAGE_QUERY,
            component: 'GraphqlPassportContainer.js',
            message: 'No content returned for query',
            env: GRAPHQL_ENV,
        });
    } else {
        const passportData = data?.findContent?.content?.entries || [];

        setPassportCodeAction(passportData[0]);
    }

    return null;
};

GraphqlPassportContainer.propTypes = {
    setPassportCodeAction: func.isRequired,
    brand: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
});
const mapDispatchToProps = (dispatch) => ({
    setPassportCodeAction: bindActionCreators(setPassportData, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(GraphqlPassportContainer);
